<template>
  <div id="contenedor-agregar-nueva-fuentefinanciera">
    <v-form ref="registrarFuenteFinanciera" v-model="formularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar nueva fuente financiera
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            label="Nombre de la Fuente Financiera"
            v-model="fuenteFinanciera.nombre"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
          <custom-select
            label="Origen"
            :items="itemsorigen"
            v-model="fuenteFinanciera.origen"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-select>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarFuenteFinanciera"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoFuentesFinancieras from './mixCatalogoFuentesFinancieras';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogosFuentesfinancierasNuevo',
  mixins: [mixCatalogoFuentesFinancieras],
  components: {
    CustomTextField,
    CustomSelect,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      itemsorigen: ['Estatal', 'Federal', 'Municipal', 'Privado', 'Mixto'],
      fuenteFinanciera: {
        nombre: '',
        origen: '',
      },
    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.registrarFuenteFinanciera.reset();
    },
  },
};
</script>

<style>

</style>
